import { render } from "./DistributorManagement.vue?vue&type=template&id=2a5bb1c7&scoped=true"
import script from "./DistributorManagement.vue?vue&type=script&lang=js"
export * from "./DistributorManagement.vue?vue&type=script&lang=js"

import "./DistributorManagement.vue?vue&type=style&index=0&id=2a5bb1c7&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a5bb1c7"]])

export default __exports__